import { AuthenticationService } from '@app/01.global/services/authentication.service';

export function appInitializer(authenticationService: AuthenticationService) {
	return () =>
		new Promise<void>((resolve) => {
			authenticationService.setLanguage();
			resolve();
		});
}
